import bowser from "bowser";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import ConfirmActionDialog from "@/components/Common/ConfirmActionDialog";

import supportedBrowsers from "@/supportedBrowsers";

const BrowserWarning = () => {
  const { t } = useTranslation();
  const disableBrowserWarning =
    import.meta.env.REACT_DISABLE_BROWSER_WARNING === "true";

  const notSupported = React.useMemo(() => {
    if (disableBrowserWarning) {
      return null;
    }
    const userAgent = window.navigator.userAgent;
    if (!supportedBrowsers.test(userAgent)) {
      const browser = bowser.getParser(userAgent).getBrowser();
      return {
        name: browser.name || "Unknown",
        version: browser.version || "Unknown",
      };
    }
    return null;
  }, [disableBrowserWarning]);

  const [showUnsupportedBrowserDialog, setShowUnsupportedBrowserDialog] =
    useState(true);

  if (!notSupported) {
    return null;
  }

  return (
    <>
      <ConfirmActionDialog
        open={showUnsupportedBrowserDialog}
        onOpenChange={setShowUnsupportedBrowserDialog}
        title={t("unsupported_browser")}
        description={t("unsupported_browser_description", notSupported)}
        onConfirm={() => setShowUnsupportedBrowserDialog(false)}
        confirmText={t("close")}
        hideCancel
      />

      <div className="sticky top-0 z-50 flex h-32 w-full items-center justify-center bg-gray-700/85 text-center text-gray-300">
        <div>
          <h2 className="text-lg font-medium">{t("unsupported_browser")}</h2>
          <p className="text-sm">
            {t("unsupported_browser_description", notSupported)}
          </p>
        </div>
      </div>
    </>
  );
};

export default BrowserWarning;
